export const modal = {
    state: {
        status: [],
        payload: null,
        changesHaveBeenMade: false
    },
    mutations: {
        MODAL_SHOW(state, name) {
            // turn on current modal
            const idx = state.status.findIndex(item => item.name === name)
            if(idx === -1) {
                this.$vue.set(state.status, state.status.length, {
                    name,
                    state: true
                })
            } else {
                this.$vue.set(state.status, idx, {
                    name,
                    state: true
                })
            }
            // reset modal state
            if(name === 'products') {
                state.changesHaveBeenMade = false
            }
        },
        MODAL_HIDE(state) {
            state.status.forEach(item => {
                this.$vue.set(item, 'state', false)
            })
        },
        MODAL_TOGGLE(state) {
            state.status = !state.status
        },
        MODAL_SET_PAYLOAD(state, payload) {
            this.$vue.set(state, 'payload', payload)
        },
        MODAL_RESET_PAYLOAD(state, payload) {
            this.$vue.set(state, 'payload', null)
        },
        MODAL_CHANGES_HAVE_BEEN_MADE(state, changesHaveBeenMade) {
            state.changesHaveBeenMade = changesHaveBeenMade
        }
    },
    actions: {
        modalShow({ commit }, payload) {
            commit('MODAL_SHOW', payload.name)
            commit('MODAL_SET_PAYLOAD', payload.payload)
        },
        modalHide({ state, commit, dispatch }, name) {
            commit('MODAL_HIDE')
            commit('MODAL_RESET_PAYLOAD')
            if(name === 'products' && state.changesHaveBeenMade) {
                dispatch('addNotification', {
                    type: 'success',
                    content: 'Twoje zamówienie zostało zmodyfikowane',
                    name: 'cart-change'
                })
            }
        },
        modalchangesHaveBeenMade({ commit }, state) {
            commit('MODAL_CHANGES_HAVE_BEEN_MADE', state)
        }
    },
    getters: {
        modalStatus: (state) => (name) => {
            if(state.status.find(item => item.name === name) !== undefined) {
                return state.status.find(item => item.name === name).state
            } else return false
        },
        modalPayload: (state) => {
            return state.payload
        }
    }
}
